import './Root.scss';
import Component from './Root.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);